import { createSlice } from '@reduxjs/toolkit'

//Initial State of appslice
const initialState = {
    
    rolesList: [],
    isLoading: false,
    initialIndexSetting: 0
}

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setRoles(state, action) {
            state.rolesList = action.payload
        },
        setLoading(state, action) {
            state.isLoading = action.payload
        },
        setIndex(state, action) {
            state.initialIndexSetting = action.payload
        }
    }
})



export const { setRoles, setLoading, setIndex } = appSlice.actions
export default appSlice.reducer